module.exports = __webpack_public_path__ + "static/media/login-background-new.1129b79d.jpg";